import Html from "./html";

class SowingCalendar {

    constructor(
        private html: Html
    ) { }

    load(crop: string): void {
        this.html.fetchText('/crop/' + crop)
            .then((html: string) => {
                const cropItem = this.html.q('#crop_item');
                if (!cropItem) {
                    return;
                }

                this.html.writeHTML(cropItem, html);
                this.html.addClass('#crop_item_holder', 'crop-open');  
                this.html.addClass('#crop_item_holder .crop_item_wrapper', 'translate-y-0-imp');

                const url = '/setveni-koledar/' + crop;
                history.pushState(null, "crop: " + crop, url);
            });
    }

    close(): void {
        this.html.removeClass('#crop_item_holder .crop_item_wrapper', 'translate-y-0-imp');
        this.html.removeClass('#crop_item_holder', 'crop-open');

        history.replaceState(null, "", "/setveni-koledar");
    }
}

export default SowingCalendar;